export const blockIconsAndroidGppMaybeNew = (
	<span className='material-symbols-outlined'>gpp_maybe</span>
);
